import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [


    {
        "Name": "Ms. N Sai Prasanna",
        "NameLink": "#",
        "Degree": "Chemical Engineering",
        "Batch": "January 2022",
        "GuideName": "Prof. KSMS Raghavarao",
        "CoGuideName": "Dr. Nilesh Choudhary",
        "BroadArea": "Membrane Processing for Desalination and other applications",
        "Email": "",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ch/prasanna.jpg"
    },
    {
        "Name": "Mr. Yumnam Nandan",
        "NameLink": "#",
        "Degree": "Chemical Engineering",
        "Batch": "January 2022",
        "GuideName": "Prof. KSMS Raghavarao",
        "CoGuideName": "Dr. Nilesh Choudhary",
        "BroadArea": "Osmotic Membrane Processes for desalination and its food applications",
        "Email": "",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ch/Yumnam.jpg"
    },
    {
        "Name": "Mr. Selvakumar",
        "NameLink": "#",
        "Degree": "Chemical Engineering",
        "Batch": "January 2021",
        "GuideName": "Prof. KSMS Raghavarao",
        "CoGuideName": "Dr. Trivikram Nallamilli",
        "BroadArea": "Stabilization of liquid emulsions and encapsulation of spice oleoresins for food applications",
        "Email": "",
        "Image": "https://files.iittp.ac.in/doc/PMF/Selvakumar.jpg"
    }




]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Prime Minister's Fellowship" />

            <section className="team-area fix p-relative pt-120 pb-80">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative c-lineheight2">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    {/* <i className="fal fa-graduation-cap" /> Research Scholars */}
                                </h5>
                                <h2>Prime Minister's Fellowship for Doctoral Research</h2>
                            </div>

                            <p className='mb-3'>Prime Minister’s Fellowship for Doctoral Research scheme is a prestigious initiative of Science and Engineering Research Board, Department of Science & Technology, Government of India towards the advancement of university research engagements in line with industry requirement. The scheme encourages full time PhD scholars to pursue research in “focus areas” identified by industries as well as of national priorities. There are 100 slots of fellowships available annually to researchers to pursue PhD in reputed technology and research institutions in India. Federation of Indian Chambers of Commerce & Industry (FICCI) on behalf of SERB implements the scheme.  </p>
                            <p className='mb-3'>Duration: <span className='fw-bold'> 4 Years</span> </p>


                        </div>


                        <h4>Area of Research  </h4>


                        <div className='c-lineheight3 ms-4'>

                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Science </li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Technology</li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Engineering </li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Agriculture </li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Medicine </li>

                        </div>

                        <div className='mt-3 line c-lineheight3'>
                            <h5>
                                Prime Minister’s Fellowship Guidelines: <Link className='c-link' to="http://www.serbficci-iirrada.in/PrimeMinisterFellowshipResearch.html#:~:text=Prime%20Minister's%20Fellowship%20for%20Doctoral%20Research%20scheme%20is%20a%20prestigious,in%20line%20with%20industry%20requirement." target="_blank">Click Here To View</Link><br /> </h5>



                        </div>

                    </div>
                    <div className="row mt-5">
                        {teachers.map((teacher, index) => (
                            <div key={teacher.Email} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="/team-single">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.NameLink}>{teacher.Name}</Link>
                                        </h4>
                                        <div className="text-dark c-lineheight2">
                                            <p>
                                                <i className="fal fa-graduation-cap me-2" />
                                                {teacher.Degree}
                                            </p>
                                            <p className="text-dark">Year of joining Ph.D programme : {teacher.Batch}</p>
                                            <p className="text-dark">Ph. D Advisor: {teacher.GuideName}</p>
                                            {teacher.CoGuideName && (
                                                <p className="text-dark">Ph.D Co-Advisor: {teacher.CoGuideName}</p>
                                            )}
                                            <p className="text-dark">Broad Area : {teacher.BroadArea}</p>
                                            {(teacher.Email !== undefined && teacher.Email !== "") && (
                                                <p className="text-dark">
                                                    <i className="fal fa-envelope me-1" />
                                                    Email : {teacher.Email}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main